import { getClient } from '@sanity-lib/client';

import DefaultTemplate from '@templates/default';
import { allPagesQueryLight, pageBySlugQuery } from '@sanity-lib/queries/pages';
import { fetchWithMenu } from '@sanity-lib/util/queries';

export async function getStaticPaths() {
  const client = getClient();
  const pages = await client.fetch(allPagesQueryLight);
  const slugs = pages.map((page) => {
    return page.slug[0] === '/' ? page.slug.slice(1) : page.slug;
  });

  const paths = slugs.map((slug) => ({
    params: {
      slug: slug ? slug.split('/') : [],
    },
  }));

  return {
    paths,
    fallback: 'blocking',
  };
}

export async function getStaticProps({ params, draftMode = false }) {
  const { slug } = params;
  const sanitySlug = `/${slug.join('/')}`;

  // Return 404 on any files
  if (sanitySlug.match(/\./)) {
    console.log('Ignoring slug before sanity call:', sanitySlug);
    return {
      notFound: true,
    };
  }

  console.log('Catch-all, trying Sanity:', sanitySlug);
  const client = getClient({ preview: draftMode });
  const sanityData = await fetchWithMenu(
    client,
    { content: pageBySlugQuery },
    { slug: sanitySlug },
  );
  if (sanityData.content) {
    return { props: { ...sanityData, draftMode } };
  } else {
    console.log('Catch-all, none found:', sanitySlug);
    return {
      notFound: true,
    };
  }
}

export default function Page(props) {
  return <DefaultTemplate {...props} />;
}
